import React, { act, useEffect, useRef, useState } from "react";
import AuthButton from "../../Components/AuthButton/AuthButton";
import Input from "../../Components/Input/Input";
import { useNavigate } from "react-router-dom";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import { MdClose, MdEmail, MdOutlineAddPhotoAlternate } from "react-icons/md";
import { CgAttachment, CgInbox } from "react-icons/cg";
import { PiTagSimpleFill } from "react-icons/pi";
import { FaTrashCan } from "react-icons/fa6";
import { FaEye, FaSearch } from "react-icons/fa";
import { HiTrash } from "react-icons/hi";
import { CiMenuKebab } from "react-icons/ci";
import { LuForward } from "react-icons/lu";
import { TiArrowBackOutline } from "react-icons/ti";
import { IoReturnUpBackOutline, IoSend } from "react-icons/io5";
import { IoIosArrowDown, IoMdCloudDownload } from "react-icons/io";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import { useSelector } from "react-redux";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { useDispatch } from "react-redux";
import {
  addSupport,
  deleteAdminRequest,
  EmailMarkasread,
  getSupport,
  LOADER,
  UploadImage,
} from "../../Actions/actions";
import Loader from "../../Components/Loader/Loader";
import DropDownCustom from "../../Components/DropDownCustom/DropDownCustom";
import moment from "moment";

const hardCodeCategory = [
  {
    id: "All",
    name: "All",
  },
  {
    id: "Inbox",
    name: "Inbox",
  },
  {
    id: "Trash",
    name: "Trash",
  },
];

const Support = () => {
  const dispatch = useDispatch();

  const { role, supportData, loader, loginData, subLoader, Privilages } = useSelector(
    (state) => state.userReducer
  );

  const navigate = useNavigate();
  const dropdownOptions = [
    { value: "Technical Issue", label: "Technical Issue" },
    { value: "Billing Issue", label: "Billing Issue" },
    { value: "UI/UX Issue", label: "UI/UX Issue" },
    { value: "Performance Issue", label: "Performance Issue" },
    { value: "Data Loss/Corruption", label: "Data Loss/Corruption" },
    { value: "Integration Issue", label: "Integration Issue" },
    { value: "Security Concern", label: "Security Concern" },
    {
      value: "Access Denied/Permission Issue",
      label: "Access Denied/Permission Issue",
    },
    { value: "Bug Report", label: "Bug Report" },
    { value: "Configuration Issue", label: "Configuration Issue" },
    { value: "Mobile App Issue", label: "Mobile App Issue" },
    { value: "Web App Issue", label: "Web App Issue" },
    { value: "Payment Failure", label: "Payment Failure" },
    { value: "Subscription Issue", label: "Subscription Issue" },
    { value: "Notification Issue", label: "Notification Issue" },
    { value: "Other", label: "Other" },
  ];

  const [supportCategories, setSupportCategories] = useState([]);
  const [category, setCategory] = useState("");
  const [inbox, setInbox] = useState([]);
  const [seletedInboxId, setSeletedInboxId] = useState(null);
  const [seletedInboxIdbolean, setSeletedInboxIdbolean] = useState(false);
  const [inboxLoader, setInboxLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [sendEmailLoader, setSendEmailLoader] = useState(false);
  const [messagesLoader, setMessagesLoader] = useState(false);
  const [seletedInbox, setSeletedInbox] = useState(null);
  const [activeTab, setActiveTab] = useState("All");
  const [message, setMessage] = useState("");
  const [repliesMsgs, setRepliesMsgs] = useState("");
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({
    subject: "",
    issueCategory: "",
    message: "",
    attachmentUrl: "",
  });
  const [errors, setErrors] = useState({
    subject: "",
    issueCategory: "",
    message: "",
    attachmentUrl: null,
    emiratesId: "",
  });
  useEffect(() => {
    getSupportData();

  }, [])
  const validateForm = (formData) => {
    let newErrors = {};

    if (!formData.subject) {
      newErrors.subject = "Subject is required";
    }
    if (!formData.issueCategory) {
      newErrors.issueCategory = "Report Type is required";
    }
    if (!formData.message) {
      newErrors.message = "Message is required";
    }
    if (!formData.attachmentUrl) {
      newErrors.attachmentUrl = "Attachment is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const getSupportData = () => {
    dispatch(getSupport(loginData?.accessToken));
  };

  const Reset = () => {
    setFormData({
      subject: "",
      issueCategory: "",
      message: "",
      attachmentUrl: null,
    });
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleDropDown = (selectedOption) => {
    setFormData({ ...formData, issueCategory: selectedOption.value });
    setErrors({ ...errors, issueCategory: "" });
  };
  const selectedValue = dropdownOptions?.find(
    (option) => option.value === formData.issueCategory
  );

  const handleSubmit = () => {
    console.log("Submitted Data:", formData);
    if (validateForm(formData)) {
      dispatch(
        addSupport(formData, loginData?.accessToken, () => {
          Reset();
          getSupportData();
        })
      );
    }
  };
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    dispatch(
      UploadImage(e.target.files[0], "", (data) => {
        // let datanew = data.data.fileUrl
        // let attachments = []
        // attachments.push({ datanew })
        setFormData({ ...formData, attachmentUrl: data.data.fileUrl });
      })
    );
  };

  console.log(formData, "pp");
  const recentRequests = [
    {
      id: "#10234",
      title: "Report generation error",
      category: "Bug/Technical Issue",
      date: "2024-08-15",
    },
    {
      id: "#10234",
      title: "Report generation error",
      category: "Bug/Technical Issue",
      date: "2024-08-15",
    },
    {
      id: "#10234",
      title: "Report generation error",
      category: "Bug/Technical Issue",
      date: "2024-08-15",
    },
    {
      id: "#10234",
      title: "Report generation error",
      category: "Bug/Technical Issue",
      date: "2024-08-15",
    },
  ];
  const PrivilagesArray = Privilages?.length > 0 ? (Privilages.filter(
    (item) => item.feature === 'Support'
  )) : []
  const Sidebar = () => {
    return (
      <div className="w-56 py-6 pl-4 pr-2  flex flex-col">
        <nav className="space-y-4">
          {supportCategories.map((item) => {
            const icon = {
              All: <MdEmail />,
              Inbox: <CgInbox />,
              Trash: <FaTrashCan />,
            };
            return (
              <SidebarItem
                icon={
                  icon[item.name] || (
                    <PiTagSimpleFill className="text-red-500" />
                  )
                }
                label={item.name}
                active={activeTab === item.name}
                count={item?.count}
                onClick={() => {
                  setSeletedInbox(null);
                  setActiveTab(item.name);
                }}
              />
            );
          })}
        </nav>
      </div>
    );
  };

  const SidebarItem = ({ icon, label, active, count, onClick }) => (


    <div
      className="flex flex-row  w-full items-center text-gray-700 hover:text-indigo-600 cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-center space-x-3 flex-grow">
        {icon}
        <span
          className={`font-medium ${active ? "text-gray-800" : "text-gray-400"
            } text-sm`}
        >
          {label}
        </span>
      </div>
      {label == 'All' || label == 'Inbox' || label == 'Trash' || count <= 0 ? null :
        <div className="text-xs bg-primary text-white rounded-full px-1.5 py-0.5">
          {count}
        </div>
      }

    </div>

  );

  const EmailList = ({ setSearch, search }) => {


    return (
      <div className="w-80 bg-white p-4 rounded-2xl">
        <div className="relative w-full">
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full"
          />
        </div>

        <div className="space-y-4 mt-4 max-h-[500px] overflow-y-scroll">
          {messagesLoader ? (
            <Loader />
          ) : (
            inbox?.map((email, index) => {
              console.log(email, ";");
              if (email?.client?.toLocaleLowerCase()?.includes(search) || email?.id?.toLocaleLowerCase()?.includes(search)) {
                return (
                  <EmailItem
                    index={index}
                    id={email?.id}
                    name={email?.client}
                    message={email?.subject}
                    time={email?.timeAgo}
                    isDotShow={email?.isRead}
                    logo={email?.clientLogo}
                  />
                );
              }
            })
          )}
        </div>
      </div>
    );
  };

  const EmailItem = ({ id, index, name, message, time, isDotShow, logo }) => (
    <div
      key={id}
      className="flex items-center justify-between space-x-3 p-2 rounded-lg hover:bg-gray-100 cursor-pointer"
      onClick={() => {
        dispatch(
          EmailMarkasread(id, loginData?.accessToken, () => {
            let temp = [...inbox];
            temp[index]["isRead"] = true;
            setInbox(temp);
          })
        );
        setSeletedInboxId(id);
        setSeletedInboxIdbolean(!seletedInboxIdbolean);
      }}
    >
      <div className="flex flex-row gap-2 items-center">
        <div className="w-10 h-10 bg-gray-300 rounded-full items-center justify-center flex">
          {logo ? (
            <img src={logo} />
          ) : (
            <p className="font-normal text-gray-400 text-lg">
              {name?.slice(0, 1)}
            </p>
          )}
        </div>
        <div>
          <p className="text-sm font-semibold text-gray-800">{name}</p>
          <p className="text-xs font-regular text-gray-500">{message}</p>
        </div>
      </div>
      <div className=" flex flex-row items-center gap-2 min-w-[50px]">
        <p className="text-xs text-gray-400 ml-auto">{time}</p>
        {!isDotShow && <div className="w-2 h-2 bg-blue-400 rounded-full"></div>}
      </div>
    </div>
  );

  const EmailContent = () => {
    return inboxLoader ? (
      <div className="flex-1 overflow-y-scroll self-center">
        <Loader />
      </div>
    ) : (
      <div className="flex-1 bg-white rounded-2xl overflow-y-scroll">
        <div className="flex items-center justify-between border-b border-dashed p-4">
          <span className="bg-red-100 text-red-600 text-xs font-bold px-2 py-1 rounded">
            {seletedInbox?.issueCategory}
          </span>
          <div className="flex items-center space-x-4 text-gray-500">
            {seletedInbox?.issueCategory !== 'Trash' &&
              <HiTrash
                onClick={() => {
                  console.log(loginData?.accessToken, "o");
                  dispatch(
                    deleteAdminRequest(
                      loginData?.accessToken,
                      seletedInbox?.id,
                      () => {
                        setSeletedInbox(null);
                        getSupportCategoryById();
                      }
                    )
                  );
                }}
                size={20}
                className="cursor-pointer hover:text-red-600"
              />}
            {/* <CiMenuKebab size={18} className="cursor-pointer" /> */}
          </div>
        </div>

        <div className="p-4 border-b border-dashed flex flex-row items-center justify-between ">
          <div>
            <h2 className="text-sm text-gray-800 font-semibold flex-1">
              {seletedInbox?.subject}
            </h2>
            <p className="text-xs text-gray-400 font-regular">
              {`${seletedInbox?.id}`}
            </p>
          </div>
          <div className="flex flex-col items-end gap-1">
            {/* <div className="flex flex-row items-center gap-2">
              <IoReturnUpBackOutline className="text-gray-500 cursor-pointer hover:text-gray-800" />
              <TiArrowBackOutline className="text-gray-500 cursor-pointer hover:text-gray-800" />
              <LuForward className="text-gray-500 cursor-pointer hover:text-gray-800" />
            </div> */}
            <p className="text-xs text-gray-400 font-regular text-right ">
              {moment(seletedInbox?.createdAt).format("DD/MM/yy h:mm:A")}
            </p>
          </div>
        </div>

        <div className="p-4 flex flex-row gap-2">
          <div className="w-10 h-10 bg-gray-300 rounded-full items-center justify-center flex">
            {seletedInbox?.client?.logo ? (
              <img src={seletedInbox?.client?.logo} />
            ) : (
              <p className="font-normal text-gray-400 text-lg">
                {seletedInbox?.client?.contactPerson?.slice(0, 1)}
              </p>
            )}
          </div>
          <div className="flex flex-col gap-1">
            <span className="flex flex-row items-center gap-2">
              <p className="text-sm font-semibold">
                {seletedInbox?.client?.contactPerson}
              </p>
              {/* <p className="text-xs text-gray-400 font-regular">
                {`<${seletedInbox?.client?.email}>`}
              </p> */}
            </span>
            <p className="text-xs text-gray-400 font-regular">
              {seletedInbox?.createdBy?.email}
            </p>
          </div>
        </div>
        {seletedInbox?.attachments?.length > 0 ? (
          <div className="px-4">
            <div className="w-full bg-gray-200 py-3 px-2 rounded-lg flex flex-row items-center justify-between">
              <div className="flex flex-row items-center gap-1">
                <CgAttachment className=" text-gray-400 text-lg cursor-pointer hover:text-gray-800" />
                <p className="text-gray-600 font-regular text-xs">attachment</p>
                <IoIosArrowDown className=" text-gray-400 text-lg cursor-pointer hover:text-gray-800" />
              </div>
              <div
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = seletedInbox?.attachments[0]?.filePath;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
                className="flex flex-row items-center gap-1  cursor-pointer"
              >
                <IoMdCloudDownload className=" text-gray-800 text-lg" />
                <p className="text-gray-800 font-bold text-xs">Download</p>
              </div>
            </div>
          </div>
        ) : null}
        <div className="p-4">
          <div className="flex flex-col my-2 items-start">
            <p className="text-gray-800  text-sm px-2 py-1 rounded-lg font-semibold">
              {seletedInbox?.message}
            </p>
            {/* <p className="text-gray-400 text-xs text-left mt-1">
              {moment(seletedInbox?.createdAt).format("h:mm:A")}
            </p> */}
          </div>
        </div>

        <div className="p-4">
          {seletedInbox?.replies?.map((item) => (
            <div className={item?.createdBy?.email == seletedInbox?.createdBy?.email ? "w-[75%]  flex flex-col mt-6 items-start" : "place-self-end w-[75%] flex flex-col mt-6 items-end"}>
              <p className="text-gray-400 text-xs text-right mb-1 flex">
                {moment(item?.createdAt).format("DD/MM/yy h:mm:A")}
                <p className="ml-1 text-gray-800 text-xs font-semibold text-right mb-1">
                  {item?.createdBy?.email == seletedInbox?.createdBy?.email ? '' : `You`}
                </p>
              </p>
              <div dangerouslySetInnerHTML={{ __html: item?.message }} className={item?.createdBy?.email == seletedInbox?.createdBy?.email ? "bg-gray-50 max-w-[40%] p-2 shadow-sm rounded-lg text-gray-800 text-sm" : 'bg-gray-200 max-w-[40%] p-2 rounded-lg text-gray-800 text-sm'} />
              {item?.attachments?.length > 0 ? (
                <div
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href = item?.attachments[0]?.filePath;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                  className="flex flex-row items-center gap-1 mt-1  cursor-pointer bg-gray-100 px-2 py-1  rounded-lg"
                >
                  <IoMdCloudDownload className=" text-gray-800 text-lg" />
                  <p className="text-gray-800 font-bold text-xs">Download</p>
                </div>
              ) : null}



            </div>
          ))}
        </div>

        <div className="p-4">
          <SunEditor
            setContents={repliesMsgs}
            onChange={setRepliesMsgs}
            placeholder="Write something here..."
            setOptions={{
              minHeight: "100%",
              height: "100%",
              imageUploadUrl: null,
              imageGalleryUrl: null,
              buttonList: [
                [
                  "formatBlock",
                  "bold",
                  "underline",
                  "italic",
                  "strike",
                  "list",
                  "align",
                  "link",
                  "image",
                  "video",
                  "fullScreen",
                  "undo",
                  "redo",
                ],
              ],
              callBackSave: (content) => setRepliesMsgs(content),
            }}
          />
        </div>

        <div className="p-4 flex flex-row items-center justify-between">
          <div className="flex flex-row items-center ">
            <FileUploadIcons onFileSelect={handleFileChange} />
            {file && (
              <div className="bg-slate-300 py-1 px-2 flex flex-row text-sm font-medium ml-2 rounded-md items-center justify-between gap-1">
                {file?.name?.slice(0, 19)}
                <MdClose
                  className="text-black text-md cursor-pointer"
                  onClick={() => setFile(null)}
                />
              </div>
            )}
          </div>

          {sendEmailLoader ? (
            <Loader />
          ) : (
            <div
              className="flex flex-row items-center gap-1 bg-primary py-1 px-2 rounded-lg cursor-pointer hover:bg-blue-600"
              onClick={() => sendEmailReply()}
            >
              <p className="text-sm font-bold text-white">Send</p>
              <IoSend className=" text-white text-md" />
            </div>
          )}
        </div>
      </div>
    );
  };

  const FileUploadIcons = ({ onFileSelect }) => {
    const fileInputRef = useRef(null);

    const handleIconClick = () => {
      fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
      const files = event.target.files;
      if (files?.length > 0) {
        onFileSelect(event);
      }
    };

    return (
      <div className="flex flex-row gap-2 items-center">
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          className="hidden"
        />

        <MdOutlineAddPhotoAlternate
          className="text-gray-600 text-xl cursor-pointer hover:text-gray-800"
          onClick={handleIconClick}
        />
        <CgAttachment
          className="text-gray-600 text-lg cursor-pointer hover:text-gray-800"
          onClick={handleIconClick}
        />
      </div>
    );
  };

  const getSupportCategories = async () => {
    try {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      const response = await fetch(
        `${BaseUrl}/api/support/categories`,
        requestOptions
      );
      const result = await response.json();
      const merge = [...hardCodeCategory, ...result.categories];
      console.log(merge, 'll');
      setSupportCategories(merge);
      dispatch({ type: LOADER, payload: false });
    } catch (error) {
      console.log(error);
      dispatch({ type: LOADER, payload: false });
    }
  };

  const getInboxById = async () => {
    try {
      setInboxLoader(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      const response = await fetch(
        `${BaseUrl}/api/support/${seletedInboxId}`,
        requestOptions
      );
      const result = await response.json();
      console.log(result, "inbox by id");
      setSeletedInbox(result.request);
      setInboxLoader(false);
    } catch (error) {
      console.log(error);
      setInboxLoader(false);
    }
  };

  const getSupportCategoryById = async () => {
    try {
      setMessagesLoader(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        status: "",
        issueCategory: activeTab,
        searchTerm: "",
      });

      console.log("jhjhj", raw);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      const response = await fetch(
        `${BaseUrl}/api/support/admin/inbox`,
        requestOptions
      );

      const result = await response.json();
      console.log("inbocc", result);
      setInbox(result.inbox);
      setMessagesLoader(false);
    } catch (error) {
      console.log(error);
      setMessagesLoader(false);
    }
  };

  const sendEmailReply = async () => {
    try {
      setSendEmailLoader(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);

      const formdata = new FormData();
      formdata.append("message", repliesMsgs);
      formdata.append("attachmentUrl", formData.attachmentUrl);

      console.log(formdata, "mubeen bhund");
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
      };

      await fetch(
        `${BaseUrl}/api/support/${seletedInbox?.id}/reply`,
        requestOptions
      );
      setRepliesMsgs("");
      setFile(null);
      getInboxById();
      setSendEmailLoader(false);
    } catch (error) {
      console.log(error);
      setSendEmailLoader(false);
    }
  };

  useEffect(() => {
    getSupportCategories();
  }, []);

  useEffect(() => {
    if (seletedInboxId !== null) {
      getInboxById();
    }
  }, [seletedInboxId, seletedInboxIdbolean]);

  useEffect(() => {
    if (role == "Admin") {
      getSupportCategoryById();
    }
  }, [activeTab]);
  return (
    <ParentComponent>
      <PrimaryHeader />
      {loader ? (
        <Loader />
      ) : (
        <>
          {role === "Admin" ? (
            <div className="flex rounded-2xl bg-gray-100">
              <Sidebar />
              <div className="flex gap-2 flex-1 p-2">
                <EmailList
                  search={search}
                  setSearch={setSearch}

                />
                {seletedInbox && <EmailContent />}
              </div>
            </div>
          ) : (
            <div>
              {PrivilagesArray?.length > 0 ? (PrivilagesArray[0].accessLevel == 'Full Access' ?

                (<div className="bg-white p-6 rounded-lg shadow-md">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <Input
                      type="text"
                      placeholder="Subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      error={errors.subject}
                      float={true}
                    />
                    <div className="-mt-5">
                      <DropDownCustom
                        selectedValue={selectedValue}
                        handleChanges={handleDropDown}
                        options={dropdownOptions}
                        isSearchable={false}
                        label="Issue Type"
                        placeholder={"Select Issue Type"}
                      />
                      {errors.issueCategory !== "" && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.issueCategory}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="mt-5"></div>
                  <Input
                    textarea={true}
                    placeholder="Message"
                    name={"message"}
                    value={formData.message}
                    error={errors.message}
                    label={"Notes"}
                    onChange={(e) => handleInputChange("message", e.target.value)}
                  />
                  <div className="mt-6"></div>
                  <Input
                    type="file"
                    label="Emirates ID"
                    onChange={handleFileChange}
                    value={formData.attachmentUrl}
                    error={errors.attachmentUrl}
                  />
                  <div className="flex justify-end mt-7">
                    {subLoader ? (
                      <Loader />
                    ) : (
                      <AuthButton
                        title="Submit"
                        width="[15%]"
                        className="rounded-lg hover:bg-[#2a1627] text-white px-10"
                        onClick={handleSubmit}
                      />
                    )}
                  </div>
                </div>) : null) : (

                <div className="bg-white p-6 rounded-lg shadow-md">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <Input
                      type="text"
                      placeholder="Subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      error={errors.subject}
                      float={true}
                    />
                    <div className="-mt-5">
                      <DropDownCustom
                        selectedValue={selectedValue}
                        handleChanges={handleDropDown}
                        options={dropdownOptions}
                        isSearchable={false}
                        label="Issue Type"
                        placeholder={"Select Issue Type"}
                      />
                      {errors.issueCategory !== "" && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.issueCategory}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="mt-5"></div>
                  <Input
                    textarea={true}
                    placeholder="Message"
                    name={"message"}
                    value={formData.message}
                    error={errors.message}
                    label={"Notes"}
                    onChange={(e) => handleInputChange("message", e.target.value)}
                  />
                  <div className="mt-6"></div>
                  <Input
                    type="file"
                    label="Emirates ID"
                    onChange={handleFileChange}
                    value={formData.attachmentUrl}
                    error={errors.attachmentUrl}
                  />
                  <div className="flex justify-end mt-7">
                    {subLoader ? (
                      <Loader />
                    ) : (
                      <AuthButton
                        title="Submit"
                        width="[15%]"
                        className="rounded-lg hover:bg-[#2a1627] text-white px-10"
                        onClick={handleSubmit}
                      />
                    )}
                  </div>
                </div>
              )}
              <div className="min-w-full container mx-auto bg-white shadow-md rounded-lg">
                <div className="mt-4 bg-white rounded-t-lg p-4 flex md:flex-row sm:flex-col space-y-4 sm:space-y-0 sm:space-x-0 md:space-x-6  self-center"></div>
                <div className="overflow-x-auto bg-white rounded-b-lg">
                  <table className="min-w-full text-left">
                    <thead className="bg-[#361D3214]">
                      <tr>
                        <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px]">
                          Issue ID
                        </th>
                        <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[200px]">
                          Subject
                        </th>
                        <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[200px] text-center">
                          Issue Type
                        </th>
                        <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px] text-center">
                          Date
                        </th>
                        <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px]">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-sm text-gray-800">
                      {supportData?.map((request, index) => (
                        <tr
                          onClick={() => {
                            navigate(`/support/${request.issueId}`, {
                              state: { supportId: request.issueId },
                            });
                          }}
                          key={index}
                          className="border-t"
                        >
                          <td className="py-3 px-4">{request.issueId}</td>
                          <td className="py-3 px-4">{request.title}</td>
                          <td className="py-3 px-4 text-center">{request.category}</td>
                          <td className="py-3 px-4 text-center">{moment(request.date).format('DD-MMM-yy')}</td>
                          <td className="py-3 px-4">

                            <button
                              className="text-gray-600 hover:text-gray-900 bg-slate-100 w-8 h-8 flex items-center justify-center rounded-full"
                              onClick={() => { }}

                            >
                              <FaEye size={18} />
                            </button>

                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </ParentComponent>
  );
};

export default Support;
